'use strict';

import BiBaseDataItem from './bi-base-item';

export const INTERACTION_END_EVID = 16;

/**
 * Represents the "load finished" bi event:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/11
 *
 * It should be used to monitor the initial application load.
 */
export default class BiInteractionEndDataItem extends BiBaseDataItem {
  constructor(sessionId) {
    super(INTERACTION_END_EVID, sessionId);
  }
}



// WEBPACK FOOTER //
// ./data-items/bi-interaction-end-item.js